import { Directive,HostBinding,Input,OnInit,ElementRef,OnChanges,SimpleChanges, Inject } from '@angular/core';

@Directive({
	selector: '[abs-modals-and-alerts-wrapper]'
})
export class AbsModalsAndAlertsWrapperDirective implements OnInit{
	@Input() delay:number;
	@Input('abs-modals-and-alerts-wrapper') absModalsAndAlertsWrapper:any;
	firstElement:any;
    launchingElement:any;
    
	constructor(
        @Inject(ElementRef) private elementRef:ElementRef
    ) { }
    
    ngOnInit() {
        this.delay = this.delay | 10;
    }

    ngOnChanges(changes:SimpleChanges) {
        const absModalsAndAlertsWrapper = changes.absModalsAndAlertsWrapper;
		if (!absModalsAndAlertsWrapper.firstChange && absModalsAndAlertsWrapper.currentValue !== absModalsAndAlertsWrapper.previousValue ) {
			setTimeout(()=>{
                const el = this.elementRef.nativeElement;
                el.children[0].focus();
			},this.delay);
		}
	}	 
}
